import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { MenuListItem } from '@fcom/common/interfaces/menu.interface';
import { DirectiveModule } from '@fcom/common/directives/directive.module';

import { IconPosition } from '../../icons/enums';
import { MenuListClickEvent } from '../interfaces';
import { IconComponent } from '../../icons/icon/icon.component';

@Component({
  selector: 'fcom-menu-list',
  templateUrl: './menu-list.component.html',
  styleUrl: './menu-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DirectiveModule, NgTemplateOutlet, IconComponent],
})
export class MenuListComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  items = input.required<MenuListItem[]>();
  itemClicked = output<MenuListClickEvent>();

  handleClick(itemId: string, event: Event): void {
    this.itemClicked.emit({
      itemId,
      originalEvent: event,
    });
  }

  protected readonly IconPosition = IconPosition;
}
